import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prodScheduleOrderMonth',
  standalone: true,
})
export class ProdScheduleOrderMonthPipe implements PipeTransform {
  transform(order: any): string {
    const index = order.fields.findIndex(
      (x: any) => x.field.fld_code === 'productionorder_month'
    );
    return order.fields[index]?.value ?? '';
  }
}
